import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// routes
import { CURD_ROLES_CHR } from "../../../utils/routes";

// ---------------------------------------------------------------------

export const createRolesChr = createAsyncThunk(
  "roleschr/createRolesChr",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(CURD_ROLES_CHR, data, {
        withCredentials: true,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const getRolesChr = createAsyncThunk(
  "roleschr/getRolesChr",
  async (obj, { rejectWithValue }) => {
    try {
      const response = await axios.get(CURD_ROLES_CHR, {
        withCredentials: true,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response);
    }
  }
);

export const updateRolesChr = createAsyncThunk(
  "roleschr/updateRolesChr",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.put(CURD_ROLES_CHR, data, {
        withCredentials: true,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const deleteRolesChr = createAsyncThunk(
  "roleschr/deleteRolesChr",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.delete(CURD_ROLES_CHR, {
        data,
        withCredentials: true,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

const roleschrSlice = createSlice({
  name: "userGroups",
  initialState: {
    loading: false,
    message: "",
    errMessage: "",
    rolesData: [],
    rolesSelectedData: {},
  },
  reducers: {
    resetMessage: (state) => {
      state.message = "";
    },
    resetErrMessage: (state) => {
      state.errMessage = "";
    },
    rowSelect: (state, action) => {
      state.rolesSelectedData = action?.payload.length > 0 && action?.payload[0];
    },
  },
  extraReducers: {
    [createRolesChr.pending]: (state, action) => {
      state.loading = true;
    },
    [createRolesChr.fulfilled]: (state, action) => {
      state.loading = false;
      state.message = action?.payload?.data?.message;
    },
    [createRolesChr.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.message;
    },
    [getRolesChr.pending]: (state, action) => {
      state.loading = true;
    },
    [getRolesChr.fulfilled]: (state, action) => {
      state.loading = false;
      state.rolesData = action?.payload?.data;
    },
    [getRolesChr.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.data?.message;
    },
    [updateRolesChr.pending]: (state, action) => {
      state.loading = true;
    },
    [updateRolesChr.fulfilled]: (state, action) => {
      state.loading = false;
      state.message = action?.payload?.data?.message;
    },
    [updateRolesChr.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.message;
    },
    [deleteRolesChr.pending]: (state, action) => {
      state.loading = true;
    },
    [deleteRolesChr.fulfilled]: (state, action) => {
      state.loading = false;
      state.message = action?.payload?.data?.message;
    },
    [deleteRolesChr.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.message;
    },
  },
});

export const { resetMessage, resetErrMessage, rowSelect } =
  roleschrSlice.actions;
export default roleschrSlice.reducer;
